<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
    <v-card>
      <v-card-title class="title-modal">
        <span class="headline">Asignar a ola de preparacion</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-combobox v-model="almacen" name="name" item-title="name" item-value="id" :items="almacenes"
              label="Almacen*" autocomplete="off" :rules="[rules.requiredComboBox]" clearable
              @update:modelValue="
              () => {
                  this.loadWaves();                          
              }
              "
          ></v-combobox>
          <v-combobox 
            :disabled="!almacen"
            v-model="item.wave" name="wave" item-title="id" item-value="id" :items="waves" label="Olas*"
            autocomplete="off" :rules="[rules.requiredComboBox]" clearable />          
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="() => $emit('updateDialog')"> Cancelar </v-btn>
        <v-btn color="green" text @click="assign()" :loading="loading"> Asignar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { almacenService } from "@/libs/ws/almacenService";
import { waveService } from "@/libs/ws/waveService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  created() { },
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    updateDialog: Function,
    assignPreparation: Function,
    loading: Boolean
  },
  data: () => ({
    item: {
      wave: null      
    },
    almacen: null,
    defaultItem: null,
    waves: [],
    almacenes: [],
  }),
  watch: {

  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.loadAlmacenes();
      if(this.almacen)
          this.loadWaves();
  },
  methods: {
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {          
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadWaves() {      
      const params = {
        not_status: "EXP",//Expedido
        almacen: this.almacen
      };

      waveService.filter(params).then((response) => {
        this.waves = response.result.list;
      });
    },
    async assign() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.$emit("assignPreparation", this.item.wave);
      }
    },
  },
};
</script>